import { render } from "./FpTitle.vue?vue&type=template&id=61a976b0&lang=pug"
import script from "./FpTitle.vue?vue&type=script&lang=js"
export * from "./FpTitle.vue?vue&type=script&lang=js"

import "./FpTitle.vue?vue&type=style&index=0&id=61a976b0&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__